import { render, staticRenderFns } from "./Passflow.vue?vue&type=template&id=a60d18b4&scoped=true&"
import script from "./Passflow.vue?vue&type=script&lang=js&"
export * from "./Passflow.vue?vue&type=script&lang=js&"
import style0 from "./Passflow.vue?vue&type=style&index=0&id=a60d18b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60d18b4",
  null
  
)

export default component.exports